<script setup lang="ts">
import type { LocationMap } from '../types'
import Locations from '../data/locations.json'

const data = Locations as LocationMap
</script>

<template>
    <div
        class="overflow-hidden rounded-2xl border border-zinc-300 bg-zinc-100 dark:border-zinc-800 dark:bg-zinc-900"
    >
        <table class="w-full text-left">
            <thead
                class="border-b border-zinc-300 bg-zinc-200/60 dark:border-zinc-800 dark:bg-zinc-800/60"
            >
                <tr>
                    <th
                        class="px-4 py-3 font-medium text-zinc-700 dark:text-zinc-200"
                    >
                        Περιοχή
                    </th>

                    <th
                        class="px-4 py-3 font-medium text-zinc-700 dark:text-zinc-200"
                    >
                        Κωδικοί
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr
                    v-for="(codes, location) in data"
                    :key="location"
                    class="border-b border-zinc-200 last:border-0 dark:border-zinc-800"
                >
                    <td
                        class="px-4 py-3 font-medium text-zinc-800 dark:text-zinc-100"
                    >
                        {{ location }}
                    </td>

                    <td class="px-4 py-3">
                        <div class="flex flex-wrap gap-2">
                            <span
                                v-for="code in codes"
                                :key="code"
                                class="rounded-lg bg-zinc-200 px-3 py-1 text-sm font-medium text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300"
                            >
                                {{ code }}
                            </span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
